"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Config API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigServiceApi = exports.ConfigServiceApiFactory = exports.ConfigServiceApiFp = exports.ConfigServiceApiAxiosParamCreator = exports.CacheServiceApi = exports.CacheServiceApiFactory = exports.CacheServiceApiFp = exports.CacheServiceApiAxiosParamCreator = exports.V2TransportMode = exports.V2RepublishStatus = exports.V2PaymentMethods = exports.V2MessageSeverity = exports.V2HotelDialect = exports.V2DiffStatus = exports.V2AddOnScheduleType = exports.V2AddOnDisplayType = exports.V1PaymentProcessor = exports.V1DiscountCodeType = exports.PmsPmsBackend = exports.LocaleLang = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.LocaleLang = {
    None: 'NONE',
    En: 'EN',
    It: 'IT',
    Es: 'ES',
    Fr: 'FR',
    Da: 'DA',
    De: 'DE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PmsPmsBackend = {
    PmsBackendUndefined: 'PMS_BACKEND_UNDEFINED',
    Oracle: 'ORACLE',
    OracleOpi: 'ORACLE_OPI'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1DiscountCodeType = {
    Unspecified: 'DISCOUNT_CODE_TYPE_UNSPECIFIED',
    Promo: 'DISCOUNT_CODE_TYPE_PROMO',
    Corporate: 'DISCOUNT_CODE_TYPE_CORPORATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V1PaymentProcessor = {
    NotSet: 'NOT_SET',
    Stripe: 'STRIPE',
    Adyen: 'ADYEN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2AddOnDisplayType = {
    Unknown: 'ADD_ON_DISPLAY_TYPE_UNKNOWN',
    Toggle: 'ADD_ON_DISPLAY_TYPE_TOGGLE',
    Rocker: 'ADD_ON_DISPLAY_TYPE_ROCKER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2AddOnScheduleType = {
    Unknown: 'ADD_ON_SCHEDULE_TYPE_UNKNOWN',
    OnArrival: 'ADD_ON_SCHEDULE_TYPE_ON_ARRIVAL',
    Daily: 'ADD_ON_SCHEDULE_TYPE_DAILY',
    DailySplitQuantity: 'ADD_ON_SCHEDULE_TYPE_DAILY_SPLIT_QUANTITY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2DiffStatus = {
    Same: 'SAME',
    Different: 'DIFFERENT',
    NotCached: 'NOT_CACHED',
    NotAvailable: 'NOT_AVAILABLE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2HotelDialect = {
    Unknown: 'UNKNOWN',
    Ows: 'OWS',
    Ohip: 'OHIP'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2MessageSeverity = {
    Debug: 'DEBUG',
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR',
    Fatal: 'FATAL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2PaymentMethods = {
    Invalid: 'INVALID',
    Visa: 'VISA',
    Mastercard: 'MASTERCARD',
    Amex: 'AMEX',
    Discover: 'DISCOVER',
    Diners: 'DINERS'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2RepublishStatus = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.V2TransportMode = {
    UnknownTransport: 'UNKNOWN_TRANSPORT',
    Parking: 'PARKING',
    Train: 'TRAIN',
    Plane: 'PLANE',
    Bullet: 'BULLET',
    Chauffeur: 'CHAUFFEUR',
    Tram: 'TRAM'
};
/**
 * CacheServiceApi - axios parameter creator
 * @export
 */
const CacheServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {V2CacheStateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceCacheState: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('cacheServiceCacheState', 'body', body);
            const localVarPath = `/config.cache.v2.CacheService/CacheState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2CleanCacheRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceCleanCache: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('cacheServiceCleanCache', 'body', body);
            const localVarPath = `/config.cache.v2.CacheService/CleanCache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2DiffRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceDiff: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('cacheServiceDiff', 'body', body);
            const localVarPath = `/config.cache.v2.CacheService/Diff`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cache management
         * @param {V2PublishHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServicePublishHotel: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('cacheServicePublishHotel', 'body', body);
            const localVarPath = `/config.cache.v2.CacheService/PublishHotel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2RepublishEnvironmentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceRepublishEnvironment: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('cacheServiceRepublishEnvironment', 'body', body);
            const localVarPath = `/config.cache.v2.CacheService/RepublishEnvironment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2RollbackHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceRollbackHotel: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('cacheServiceRollbackHotel', 'body', body);
            const localVarPath = `/config.cache.v2.CacheService/RollbackHotel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CacheServiceApiAxiosParamCreator = CacheServiceApiAxiosParamCreator;
/**
 * CacheServiceApi - functional programming interface
 * @export
 */
const CacheServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.CacheServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {V2CacheStateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheServiceCacheState(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheServiceCacheState(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2CleanCacheRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheServiceCleanCache(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheServiceCleanCache(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2DiffRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheServiceDiff(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheServiceDiff(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cache management
         * @param {V2PublishHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheServicePublishHotel(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheServicePublishHotel(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2RepublishEnvironmentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheServiceRepublishEnvironment(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheServiceRepublishEnvironment(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2RollbackHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cacheServiceRollbackHotel(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cacheServiceRollbackHotel(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.CacheServiceApiFp = CacheServiceApiFp;
/**
 * CacheServiceApi - factory interface
 * @export
 */
const CacheServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.CacheServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {V2CacheStateRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceCacheState(body, options) {
            return localVarFp.cacheServiceCacheState(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2CleanCacheRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceCleanCache(body, options) {
            return localVarFp.cacheServiceCleanCache(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2DiffRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceDiff(body, options) {
            return localVarFp.cacheServiceDiff(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cache management
         * @param {V2PublishHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServicePublishHotel(body, options) {
            return localVarFp.cacheServicePublishHotel(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2RepublishEnvironmentRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceRepublishEnvironment(body, options) {
            return localVarFp.cacheServiceRepublishEnvironment(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2RollbackHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cacheServiceRollbackHotel(body, options) {
            return localVarFp.cacheServiceRollbackHotel(body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.CacheServiceApiFactory = CacheServiceApiFactory;
/**
 * CacheServiceApi - object-oriented interface
 * @export
 * @class CacheServiceApi
 * @extends {BaseAPI}
 */
class CacheServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {V2CacheStateRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheServiceApi
     */
    cacheServiceCacheState(body, options) {
        return (0, exports.CacheServiceApiFp)(this.configuration).cacheServiceCacheState(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2CleanCacheRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheServiceApi
     */
    cacheServiceCleanCache(body, options) {
        return (0, exports.CacheServiceApiFp)(this.configuration).cacheServiceCleanCache(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2DiffRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheServiceApi
     */
    cacheServiceDiff(body, options) {
        return (0, exports.CacheServiceApiFp)(this.configuration).cacheServiceDiff(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Cache management
     * @param {V2PublishHotelRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheServiceApi
     */
    cacheServicePublishHotel(body, options) {
        return (0, exports.CacheServiceApiFp)(this.configuration).cacheServicePublishHotel(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2RepublishEnvironmentRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheServiceApi
     */
    cacheServiceRepublishEnvironment(body, options) {
        return (0, exports.CacheServiceApiFp)(this.configuration).cacheServiceRepublishEnvironment(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2RollbackHotelRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CacheServiceApi
     */
    cacheServiceRollbackHotel(body, options) {
        return (0, exports.CacheServiceApiFp)(this.configuration).cacheServiceRollbackHotel(body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.CacheServiceApi = CacheServiceApi;
/**
 * ConfigServiceApi - axios parameter creator
 * @export
 */
const ConfigServiceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {V2AddHotelAddOnRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceAddHotelAddOn: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceAddHotelAddOn', 'body', body);
            const localVarPath = `/config.v2.ConfigService/AddHotelAddOn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2HotelAddTaxRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceAddHotelTax: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceAddHotelTax', 'body', body);
            const localVarPath = `/config.v2.ConfigService/AddHotelTax`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2AllHotelConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetAllHotelConfig: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetAllHotelConfig', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetAllHotelConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2GetAllHotelIdsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetAllHotelIds: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetAllHotelIds', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetAllHotelIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2GetDistributionReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetDistributionReport: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetDistributionReport', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetDistributionReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This method is used to return configuration data for a hotel.
         * @param {string} acceptLanguage
         * @param {V2GetHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotel: async (acceptLanguage, body, options = {}) => {
            // verify required parameter 'acceptLanguage' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotel', 'acceptLanguage', acceptLanguage);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotel', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetHotel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication ApiKeyAuth required
            await (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "X-Api-Key", configuration);
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2HotelAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelAddOns: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotelAddOns', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetHotelAddOns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2HotelConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelConfig: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotelConfig', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetHotelConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2HotelContextRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelContext: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotelContext', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetHotelContext`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2GetHotelEmailConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelEmailConfig: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotelEmailConfig', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetHotelEmailConfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2HotelRoomsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelRooms: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotelRooms', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetHotelRooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {V2HotelTaxGroupsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelTaxGroups: async (body, options = {}) => {
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('configServiceGetHotelTaxGroups', 'body', body);
            const localVarPath = `/config.v2.ConfigService/GetHotelTaxGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ConfigServiceApiAxiosParamCreator = ConfigServiceApiAxiosParamCreator;
/**
 * ConfigServiceApi - functional programming interface
 * @export
 */
const ConfigServiceApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ConfigServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {V2AddHotelAddOnRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceAddHotelAddOn(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceAddHotelAddOn(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2HotelAddTaxRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceAddHotelTax(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceAddHotelTax(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2AllHotelConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetAllHotelConfig(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetAllHotelConfig(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2GetAllHotelIdsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetAllHotelIds(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetAllHotelIds(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2GetDistributionReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetDistributionReport(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetDistributionReport(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * This method is used to return configuration data for a hotel.
         * @param {string} acceptLanguage
         * @param {V2GetHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetHotel(acceptLanguage, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetHotel(acceptLanguage, body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2HotelAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetHotelAddOns(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetHotelAddOns(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2HotelConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetHotelConfig(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetHotelConfig(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2HotelContextRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetHotelContext(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetHotelContext(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2GetHotelEmailConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetHotelEmailConfig(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetHotelEmailConfig(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2HotelRoomsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetHotelRooms(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetHotelRooms(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {V2HotelTaxGroupsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async configServiceGetHotelTaxGroups(body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.configServiceGetHotelTaxGroups(body, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.ConfigServiceApiFp = ConfigServiceApiFp;
/**
 * ConfigServiceApi - factory interface
 * @export
 */
const ConfigServiceApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ConfigServiceApiFp)(configuration);
    return {
        /**
         *
         * @param {V2AddHotelAddOnRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceAddHotelAddOn(body, options) {
            return localVarFp.configServiceAddHotelAddOn(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2HotelAddTaxRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceAddHotelTax(body, options) {
            return localVarFp.configServiceAddHotelTax(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2AllHotelConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetAllHotelConfig(body, options) {
            return localVarFp.configServiceGetAllHotelConfig(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2GetAllHotelIdsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetAllHotelIds(body, options) {
            return localVarFp.configServiceGetAllHotelIds(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2GetDistributionReportRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetDistributionReport(body, options) {
            return localVarFp.configServiceGetDistributionReport(body, options).then((request) => request(axios, basePath));
        },
        /**
         * This method is used to return configuration data for a hotel.
         * @param {string} acceptLanguage
         * @param {V2GetHotelRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotel(acceptLanguage, body, options) {
            return localVarFp.configServiceGetHotel(acceptLanguage, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2HotelAddOnsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelAddOns(body, options) {
            return localVarFp.configServiceGetHotelAddOns(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2HotelConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelConfig(body, options) {
            return localVarFp.configServiceGetHotelConfig(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2HotelContextRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelContext(body, options) {
            return localVarFp.configServiceGetHotelContext(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2GetHotelEmailConfigRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelEmailConfig(body, options) {
            return localVarFp.configServiceGetHotelEmailConfig(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2HotelRoomsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelRooms(body, options) {
            return localVarFp.configServiceGetHotelRooms(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {V2HotelTaxGroupsRequest} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        configServiceGetHotelTaxGroups(body, options) {
            return localVarFp.configServiceGetHotelTaxGroups(body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ConfigServiceApiFactory = ConfigServiceApiFactory;
/**
 * ConfigServiceApi - object-oriented interface
 * @export
 * @class ConfigServiceApi
 * @extends {BaseAPI}
 */
class ConfigServiceApi extends base_1.BaseAPI {
    /**
     *
     * @param {V2AddHotelAddOnRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceAddHotelAddOn(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceAddHotelAddOn(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2HotelAddTaxRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceAddHotelTax(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceAddHotelTax(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2AllHotelConfigRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetAllHotelConfig(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetAllHotelConfig(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2GetAllHotelIdsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetAllHotelIds(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetAllHotelIds(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2GetDistributionReportRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetDistributionReport(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetDistributionReport(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This method is used to return configuration data for a hotel.
     * @param {string} acceptLanguage
     * @param {V2GetHotelRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetHotel(acceptLanguage, body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetHotel(acceptLanguage, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2HotelAddOnsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetHotelAddOns(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetHotelAddOns(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2HotelConfigRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetHotelConfig(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetHotelConfig(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2HotelContextRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetHotelContext(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetHotelContext(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2GetHotelEmailConfigRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetHotelEmailConfig(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetHotelEmailConfig(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2HotelRoomsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetHotelRooms(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetHotelRooms(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {V2HotelTaxGroupsRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigServiceApi
     */
    configServiceGetHotelTaxGroups(body, options) {
        return (0, exports.ConfigServiceApiFp)(this.configuration).configServiceGetHotelTaxGroups(body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ConfigServiceApi = ConfigServiceApi;
